module.exports = __webpack_public_path__ + "img/googlePlay.1e91d02c.png";